import { useAppStore } from '../store/useAppStore.js';

export function GuidePendingView() {
  const role = useAppStore((s) => s.role);
  const isGuide = role === 'guide';
  return (
    <div className="max-w-md mx-auto card p-7 lg:p-10 has-grain animate-fade-up text-center">
      <h2 className="h-card mb-2 text-ink-900 dark:text-ink-100">
        Your {isGuide ? 'application' : 'account'} is under review
      </h2>
      <p className="hint">
        {isGuide
          ? "Thanks for applying to be a Deaf Guide! An admin is reviewing your application. We'll email you once it's approved — after that you'll show up to learners and can start taking calls."
          : "An admin is reviewing your registration. We'll email you once your account is approved."}
      </p>
    </div>
  );
}
